export const processDefaultAndTotals = (Schema) => {
  const defaults = {}
  const required = {}
  let countTotalFields = 0

  ;(function _recurseSchema(obj) {
    Object.entries(obj).forEach(([key, value]) => {
      if (!value) {
        return
      }
      if (value._name) {
        // it's a grouping. recurse the grouped things
        const { _name, ...nestedObj } = value
        _recurseSchema(nestedObj)
      } else {
        // it's a field. do stuff...
        countTotalFields += 1
        if (value.default != null) {
          // check for null or undefined
          defaults[key] = value.default
        }
        if (value.required) {
          required[key] = value.name
        }
      }
    })
  })(Schema)

  return { defaults, countTotalFields, required }
}
